import React from 'react';
import { Ticket } from '@app/api/models/Tickets';
import StatusBox from '../../../components/thread/status/Status';

const TicketStatus = ({ status, ...rest }: Ticket) => {
    return <StatusBox status={status} {...rest} />;
};

export default TicketStatus;
